{
  "nav": {
    "stats": "Statistik",
    "registerCatch": "Registrera fångst",
    "myCatches": "Mina fångster",
    "myFiskekort": "Mina fiskekort",
    "myBookings": "Mina bokningar",
    "profile": "Profil",
    "login": "Logga in",
    "logout": "Logga ut",
    "admin": "Admin",
    "valdAdmin": "Vald-admin",
    "riverAdmin": "Älvadmin",
    "history": "Historik",
    "buyFiskekort": "Köp fiskekort",
    "registerLink": "Skapa konto",
    "loggFiskedag": "Logga fiskedag",
    "contact": "Kontakta oss",
    "language": "Språk",
    "fiskeHer": "Fiska här",
    "sectionFishing": "Fiske",
    "sectionExplore": "Utforska",
    "sectionAccount": "Mitt konto",
    "sectionManagement": "Administration",
    "sectionForOwners": "För ägare",
    "sellFiskekort": "Sälj fiskekort",
    "riverOwnersAssoc": "Älvägarförening",
    "photoContest": "Fototävling",
    "adminPhotoContest": "Fototävling (admin)",
    "menu": "Meny",
    "openMenu": "Öppna meny",
    "closeMenu": "Stäng meny",
    "privacy": "Integritet",
    "rivers": "Älvar och vald"
  },
  "stats": {
    "title": "Fångststatistik",
    "filterYear": "År",
    "filterMonth": "Månad",
    "filterWeek": "Vecka",
    "filterDay": "Dag",
    "totalCatches": "Antal fångster",
    "totalWeight": "Total vikt",
    "avgWeight": "Genomsnittsvikt",
    "biggestFish": "Största fisk",
    "released": "Återutsatt",
    "recentCatches": "Senaste fångster",
    "noData": "Inga fångster under vald period",
    "allRivers": "Alla älvar",
    "allValds": "Alla vald",
    "viewVald": "Se valdsida →",
    "uniqueAnglers": "Fiskare",
    "cpue": "Fångst per fiskare",
    "registerCatchDesc": "Registrera fisken du har fångat med art, vikt och längd. Ditt namn visas inte offentligt som standard.",
    "startFishingDesc": "Tryck när du börjar fiska och på ”Klar med fisket” när du är klar. Vi sparar bara tidpunkter, aldrig position.",
    "intro": "Lakseborsen är en öppen <b>laxbörs</b> som samlar <b>laxstatistik</b> i realtid från registrerade norska lax- och havsöringsälvar. Se aktuella fångstsiffror för <b>{{year}}</b> — antal fångster, totalvikt, medelvikt och största fisk per älv eller sträcka. Gå till <history>fångsthistorik</history> för säsonger tillbaka till 2014."
  },
  "catch": {
    "title": "Registrera fångst",
    "vald": "Vald (fiskezon)",
    "selectVald": "Välj vald…",
    "fishType": "Fiskart",
    "weight": "Vikt (kg)",
    "weightKg": "Vikt (kg)",
    "length": "Längd (cm)",
    "lengthCm": "Längd (cm)",
    "date": "Datum",
    "time": "Tid",
    "gear": "Redskap",
    "photo": "Foto (valfritt)",
    "photoUploadFailed": "Bilduppladdning misslyckades",
    "released": "Återutsatt",
    "fromBoat": "Från båt",
    "sex": "Kön (valfritt)",
    "sexTypes": {
      "hann": "Hane",
      "hunn": "Hona"
    },
    "seaLice": "Laxlus",
    "fisher": "Fiskare",
    "roer": "Roddare",
    "onBehalf": {
      "question": "Vem är den här fångsten för?",
      "self": "Mig själv",
      "other": "En annan fiskare",
      "fisherName": "Fiskarens namn",
      "fisherNamePlaceholder": "Ange namn",
      "recent": "Nyligen använda"
    },
    "conditions": "Förhållanden vid fangsten",
    "airTemp": "Lufttemperatur",
    "precipitation": "Nederbörd",
    "windSpeed": "Vindstyrka",
    "waterTemp": "Vattentemperatur",
    "waterFlow": "Vattenflöde",
    "nveStationSource": "Källa: {{station}}",
    "weatherPending": "Väderdata tillgängligt om ca 5 dagar",
    "submit": "Registrera",
    "submitting": "Sparar…",
    "success": "Fångst registrerad!",
    "offlineDraft": "Sparad lokalt — skickas automatiskt när du är online",
    "fishTypes": {
      "laks": "Atlantlax",
      "brunørret": "Bäcköring",
      "sjøørret": "Havsöring",
      "pukkellaks": "Puckellax",
      "oppdrettslaks": "Odlad lax",
      "støing": "Støing",
      "røye": "Röding",
      "ørret": "Havsöring"
    },
    "gearTypes": {
      "flue": "Flugfiske",
      "wobbler": "Wobbler",
      "spinner": "Spinner",
      "sluk": "Skädderfiske",
      "mark_orm": "Mask / bete",
      "rapala": "Rapala",
      "annet": "Annat"
    },
    "errors": {
      "valdRequired": "Välj ett fiskevårdsområde",
      "weightInvalid": "Vikten måste vara mellan 0.1 och 100 kg",
      "lengthInvalid": "Längden måste vara mellan 5 och 250 cm",
      "dateRequired": "Ange datum och klockslag",
      "fisherNameRequired": "Ange fiskarens namn"
    },
    "fishingDayPrompt": "Fiskat idag utan fångst?",
    "logFishingDay": "Logga fiskedag",
    "logFishingDayDone": "Fiskedag registrerad ✓",
    "edit": "Redigera",
    "editTitle": "Redigera fangst",
    "editSave": "Spara ändringar",
    "editSaved": "Fångst uppdaterad!",
    "locate": {
      "button": "Använd min plats",
      "locating": "Hittar din plats…",
      "found": "Hittade närmaste vald: {{vald}}",
      "unsupported": "Plats stöds inte i den här webbläsaren",
      "denied": "Du måste tillåta platsåtkomst för att använda detta",
      "failed": "Kunde inte hämta din plats",
      "noneFound": "Inga vald i närheten har platsdata än"
    },
    "photoPendingOffline": "Bilden laddas upp automatiskt när du är online igen",
    "photoChange": "Byt bild",
    "photoAdd": "Lägg till bild",
    "photoPreviewAlt": "Förhandsvisning",
    "fishingDayOffline": "Sparat lokalt — loggas automatiskt när du är online",
    "showNamePublic": "Visa mitt namn offentligt",
    "showNamePublicDesc": "Av som standard. Fångsten räknas ändå i statistiken."
  },
  "bulk": {
    "title": "Registrera småfisk (bulk)",
    "intro": "Fiskade du många små öringar? Registrera dem alla på en gång istället för en i taget.",
    "count": "Antal fiskar",
    "countHint": "Registrerar {{count}} fiskar",
    "allReleased": "Alla återsatta",
    "optionalMeasurements": "Valfria mått (lämna tomt om okänt)",
    "avgWeight": "Snittsvikt (kg)",
    "avgLength": "Snittlängd (cm)",
    "lengthHint": "Vanligtvis under 40 cm",
    "submit": "Registrera {{count}} fiskar",
    "submitting": "Registrerar…",
    "success": "{{count}} fiskar registrerade!",
    "successDetail": "Fångsterna har sparats och visas i statistiken.",
    "registerMore": "Registrera mer",
    "backToForm": "Vanlig registrering",
    "bulkLink": "Fiskade du många små öringar? → Bulkregistrering",
    "errors": {
      "countInvalid": "Antal måste vara mellan 1 och 50"
    },
    "decreaseCount": "Minska",
    "increaseCount": "Öka"
  },
  "myCatches": {
    "title": "Mina fångster",
    "empty": "Du har inte registrerat några fångster ännu.",
    "registerFirst": "Registrera din första fångst",
    "exportCsv": "Ladda ned mina fångster",
    "exportError": "Kunde inte ladda ned fångsterna"
  },
  "profile": {
    "title": "Min profil",
    "displayName": "Namn",
    "language": "Språk",
    "save": "Spara",
    "saved": "Sparat!",
    "security": "Säkerhet",
    "passkey": "Passkey (biometrisk inloggning)",
    "passkeyDesc": "Logga in snabbt med fingeravtryck, ansiktsigenkänning eller en säkerhetsnyckel.",
    "registerPasskey": "Registrera passkey",
    "addPasskey": "Lägg till ny passkey",
    "passkeyDefaultLabel": "Passkey",
    "passkeyAdded": "Tillagd {{date}}",
    "deletePasskey": "Ta bort",
    "confirmDeletePasskey": "Ta bort passkey \"{{label}}\"?",
    "hideNamePublic": "Visa mina fångster anonymt",
    "hideNamePublicDesc": "Ditt namn döljs från offentlig fångststatistik. Fångsterna räknas ändå i statistiken.",
    "deleteAccount": "Radera konto",
    "deleteAccountDesc": "Tar bort ditt namn, e-post och annan personlig information från din profil. Dina fångster behålls anonymiserade, vilket krävs enligt lag för fångstrapportering.",
    "confirmDeleteAccount": "Är du säker på att du vill radera ditt konto? Detta kan inte ångras.",
    "privacy": "Integritet",
    "privacyDesc": "Ladda ned all data vi har om dig. Se även integritetspolicyn (på norska).",
    "exportData": "Ladda ned mina data"
  },
  "admin": {
    "title": "Admin-dashboard",
    "totalCatches": "Totalt fångster",
    "catchesThisYear": "Fångster i år",
    "totalFishers": "Aktiva fiskare",
    "totalUsers": "Registrerade användare",
    "tabCatches": "Fångster",
    "tabUsers": "Användare",
    "dateFrom": "Från datum",
    "dateTo": "Till datum",
    "allFishTypes": "Alla fiskarter",
    "allReleased": "Alla (återutsatt)",
    "keptOnly": "Endast behållna",
    "releasedOnly": "Endast återutsatta",
    "applyFilters": "Filtrera",
    "resetFilters": "Återställ",
    "catchCount": "{{count}} fångster",
    "exportCsv": "Ladda ner CSV",
    "deleteSelected": "Radera valda ({{count}})",
    "confirmBulkDeleteCatches": "Radera {{count}} fångst(er)? Detta kan inte ångras.",
    "bulkDeleteDone": "{{count}} fångst(er) raderade.",
    "selectAllOnPage": "Välj alla på sidan",
    "selectRow": "Välj rad",
    "fisher": "Fiskare",
    "yes": "Ja",
    "no": "Nej",
    "prevPage": "Föregående",
    "nextPage": "Nästa",
    "userName": "Namn",
    "userEmail": "E-post",
    "userRole": "Roll",
    "userCatches": "Fångster",
    "registered": "Registrerad",
    "role_fisher": "Fiskare",
    "role_admin": "Admin",
    "promote": "Gör till admin",
    "demote": "Ta bort admin",
    "tabValds": "Fiskevatten",
    "valdName": "Fiskevatten",
    "valdRiver": "Älv",
    "valdOwner": "Ägare",
    "valdNoOwner": "Ingen ägare",
    "assignOwner": "Tilldela ägare",
    "clearOwner": "Ta bort ägare",
    "searchVald": "Sök zone…",
    "searchUser": "Sök användare (namn eller e-post)…",
    "search": "Sök",
    "select": "Välj",
    "filterRiver": "Filtrera på älv",
    "allRivers": "Alla älvar",
    "searchUsers": "Sök på namn eller e-post…",
    "ownedValds": "Vald",
    "selectVald": "Välj vald…",
    "assignVald": "Tilldela vald",
    "removeValdOwner": "Ta bort ägarskap",
    "role_river_admin": "Älvadmin",
    "promoteRiverAdmin": "Gör till älvadmin",
    "demoteRiverAdmin": "Ta bort älvadmin",
    "selectRiver": "Välj älv…",
    "selectRiverSystem": "Välj älvsystem…",
    "makeRiverAdmin": "Gör till älvadmin",
    "inviteOwner": "Bjud in valdägare",
    "inviteHint": "Ange e-postadressen till den framtida valdägaren.",
    "inviteEmailPlaceholder": "Ägarens e-post",
    "sendInvite": "Skicka inbjudan",
    "inviteSentOk": "Inbjudan skickad till {{email}}",
    "inviteAssignedDirect": "{{email}} är redan användare och tilldelades ägarskap",
    "pendingInvite": "Väntar på {{email}}",
    "edit": "Redigera",
    "riverClosed": "Tillfälligt stängd",
    "riverDescription": "Beskrivning",
    "riverFishingRules": "Fiskeregler",
    "riverFlags": "Status",
    "riverMain": "Huvudälv",
    "riverMunicipalities": "Kommun",
    "riverName": "Namn",
    "riverNveId": "NVE-stations-ID",
    "riverNveName": "NVE-stationsnamn",
    "riverRequiresDisinfection": "Kräver desinfektion",
    "riverSeason": "Säsong",
    "riverSeasonClose": "Säsong stänger (MM-DD)",
    "riverSeasonOpen": "Säsong öppnar (MM-DD)",
    "riverSystem": "System",
    "searchRiver": "Sök älv (namn, kommun, system)…",
    "tabRivers": "Älvar"
  },
  "riverAdmin": {
    "title": "Älvadmin",
    "totalCatches": "Totalt fångster",
    "catchesThisYear": "Fångster i år",
    "allYears": "Alla år",
    "exportCsv": "Ladda ned Excel",
    "exportError": "Kunde inte ladda ned Excel",
    "tabs": {
      "fangster": "Fångster",
      "valds": "Vald",
      "elver": "Floder",
      "meldinger": "Meddelanden",
      "vilkar": "Villkor",
      "rettelser": "Rättelser",
      "fisketrykk": "Fisketryck",
      "elvekort": "Älvkort"
    },
    "rivers": {
      "title": "Säsong och stängningar",
      "hint": "Ange säsongdatum per älv. Tillfällig stängning visas för fiskare.",
      "seasonOpen": "Säsong öppnar",
      "seasonClose": "Säsong avslutas",
      "month": "Månad",
      "day": "Dag",
      "temporarilyClosed": "Tillfälligt stängd",
      "temporarilyClosedHint": "Visar en 'Tillfälligt stängd'-varning på den offentliga älvsidan. Fiskare kan fortfarande registrera fångster och köpa fiskekort.",
      "requiresDisinfection": "Kräver desinfektion",
      "requiresDisinfectionHint": "Fiskare måste bekräfta desinfektionsmetod vid köp av fiskekort",
      "save": "Spara",
      "saved": "Sparat ✓",
      "fishingRules": "Fiskeregler (text, visas offentligt)",
      "fishingRulesPlaceholder": "Ange regler, begränsningar och annan info fiskare behöver veta…",
      "description": "Beskrivning (visas offentligt)",
      "descriptionPlaceholder": "Skriv en kort beskrivning av älven…",
      "images": "Bilder (visas på älvsidan)",
      "addPhoto": "+ Lägg till bild",
      "municipalities": "Kommun",
      "municipalitiesHint": "Visas i SEO-metadata och på älvsidan. Kan endast ändras av webbplatsadministratör.",
      "municipalitiesPlaceholder": "t.ex. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "stayGuide": "Så bor du här (text, visas offentligt)",
      "stayGuidePlaceholder": "Tips om hur fiskare bäst kan bo: närmaste tätort, vad som är bra att boka tidigt, matställen, uthyrning av utrustning…",
      "nearbyPlaces": "Hotell och matställen i närheten",
      "placeName": "Namn",
      "placeDistance": "Avstånd, t.ex. ”5 min från Formofoss”",
      "placeDescription": "Kort beskrivning",
      "addPlace": "+ Lägg till plats",
      "seasonEvents": "Vad händer under säsongen (evenemang)",
      "eventTitle": "Titel, t.ex. ”Laxens dag”",
      "eventStart": "Startdatum",
      "eventEnd": "Slutdatum (valfritt)",
      "eventDescription": "Kort beskrivning",
      "addEvent": "+ Lägg till evenemang",
      "placeLat": "Latitud (valfritt)",
      "placeLon": "Longitud (valfritt)",
      "placeHighlight": "Text från sponsorn (visas som sponsrat innehåll)",
      "placeTags": "Erbjudanden",
      "placeSponsor": "Stöder älven (sponsor)",
      "placePick": "Rekommenderas? Skriv varför (visas som ”Rekommenderas av älvägarlaget”)",
      "placeLogo": "Logotyp (valfritt)",
      "sponsorReport": "Sponsorrapport",
      "sponsorReportMonth": "Månad",
      "sponsorReportLinks": "Länkklick",
      "sponsorReportMap": "Visa på karta",
      "sponsorReportCopy": "Kopiera text",
      "sponsorReportCopied": "Kopierad",
      "sponsorReportHint": "Räknar klick på sponsorlänken och ”Visa på karta”. Inga personuppgifter lagras.",
      "sponsorReportText": "{{name}}: i {{month}} klickades din länk {{link}} gånger och ”Visa på karta” användes {{map}} gånger.",
      "sub": {
        "season": "Säsong",
        "content": "Innehåll",
        "nearby": "I närheten",
        "sponsors": "Sponsorer"
      },
      "selectRiver": "Välj älv",
      "systemPlacesNote": "Gäller alla älvar i {{system}}. Lägg till en gång så visas platsen på alla älvar.",
      "sponsorReportEmpty": "Inga sponsorer än. Under ”I närheten” kan du kryssa i ”Stöttar älven (sponsor)” på en post. Sponsorerna visas då här med klick per månad.",
      "placeFamily": "För hela familjen (även för dem som inte fiskar)",
      "placePhone": "Telefon",
      "placeImage": "Bild (sponsor)",
      "sponsorTier_none": "Ingen sponsor",
      "sponsorTier_friend": "Vän till älven",
      "sponsorTier_local": "Lokalt stöd",
      "sponsorTier_supporter": "Supporter",
      "sponsorTier_partner": "Partner",
      "sponsorTier_main": "Huvudsponsor"
    },
    "valds": {
      "title": "Vald",
      "ownerLabel": "Ägare",
      "noOwner": "Ingen ägare",
      "assignOwner": "Ändra ägare",
      "clearOwner": "Ta bort ägare",
      "searchUsers": "Sök användare (namn eller e-post)…"
    },
    "messaging": {
      "title": "Skicka meddelande",
      "recipients": "Mottagare",
      "recipientValdeiere": "Valdägare",
      "recipientFishers": "Fiskare",
      "recipientAll": "Alla",
      "subject": "Ämne",
      "body": "Meddelande",
      "send": "Skicka meddelande",
      "sending": "Skickar…",
      "sent": "Skickat till {{count}} mottagare",
      "sentCount": "Skickat antal",
      "history": "Skickade meddelanden",
      "empty": "Inga meddelanden skickade ännu",
      "recipientCustom": "Enskilda",
      "emailToggle": "Skicka även via e-post ({{count}} med e-post)",
      "previewCount": "{{count}} mottagare",
      "noRecipients": "Inga mottagare hittades",
      "sendBtn": "Skicka till {{count}} mottagare"
    }
  },
  "notifications": {
    "title": "Notifikationer",
    "markAllRead": "Markera alla som lästa",
    "empty": "Inga notifikationer",
    "typeMessageReceived": "Nytt meddelande",
    "typeValdOwnerAssigned": "Vald tilldelat"
  },
  "common": {
    "loading": "Laddar…",
    "noResults": "Inga träffar",
    "error": "Något gick fel",
    "retry": "Försök igen",
    "kg": "kg",
    "cm": "cm",
    "back": "Tillbaka",
    "clear": "Rensa",
    "delete": "Ta bort",
    "paymentMethods": "Vi accepterar Vipps, kort (Visa/Mastercard) och MobilePay.",
    "cancel": "Avbryt",
    "save": "Spara",
    "previousMonth": "Föregående månad",
    "nextMonth": "Nästa månad"
  },
  "auth": {
    "loginRequired": "Logga in för att fortsätta",
    "loginForCatch": "Logga in för att registrera fångst",
    "loginForMyCatches": "Logga in för att se dina fångster",
    "loginForProfile": "Logga in för att se din profil",
    "loginHint": "Du kan logga in med Google, e-postlänk eller lösenord",
    "registerHint": "Ny användare?",
    "registerLink": "Skapa konto"
  },
  "history": {
    "title": "Fångsthistorik",
    "year": "År",
    "week": "Vecka",
    "weekLabel": "Vecka {{week}}",
    "allWeeks": "Alla veckor",
    "colTime": "Tid",
    "colFish": "Fisktyp",
    "colWeight": "Vikt",
    "colLength": "Längd",
    "colGear": "Redskap",
    "colVald": "Vald",
    "colFisher": "Fiskare",
    "colReleased": "Återutsatt"
  },
  "valdPage": {
    "river": "Älv",
    "owner": "Ägare",
    "noOwner": "Inte tillgängligt",
    "catchesThisYear": "Fiske i år",
    "fiskekortTitle": "Fiskekort",
    "noFiskekort": "Inga fiskekort tillgängliga",
    "loginToBook": "Logga in för att köpa fiskekort",
    "buy": "Köp",
    "price": "Pris",
    "durationDay": "{{count}} dag",
    "durationDays": "{{count}} dagar",
    "seasonLabel": "Säsong",
    "unlimited": "Obegränsat",
    "available": "Lediga platser",
    "remaining": "{{count}} kvar",
    "soldOut": "Slutsålt",
    "seasonOpens": "Säsongen öppnar {{date}}",
    "seasonEnded": "Säsongen är avslutad",
    "preBook": "Förhandsbokning",
    "packagesTitle": "Paket",
    "noPackages": "Inga paket tillgängliga",
    "packageIncludes": "Innehåller",
    "combinedPrice": "Kombinerat pris: {{price}} kr",
    "orderPackageBtn": "Beställ paket",
    "accommodationTitle": "Boende",
    "accommodationNoCardRequired": "Fiskekort krävs inte – vem som helst kan boka boende.",
    "noAccommodation": "Inget boende tillgängligt",
    "capacity": "{{count}} person",
    "capacity_plural": "{{count}} personer",
    "perNight": "/ natt",
    "book": "Boka boende",
    "accommodationType_hytte": "Stuga",
    "accommodationType_rom": "Rum",
    "accommodationType_telt": "Teltplats",
    "accommodationType_campingvogn": "Husvagn",
    "accommodationType_annet": "Övrigt",
    "omOssTitle": "Om oss",
    "contactPhone": "Telefon",
    "contactEmail": "E-post",
    "contactWebsite": "Webbplats",
    "tilgjengelighet": "Tillgänglighet",
    "avstandBilvei": "Avstånd till väg",
    "editVald": "Redigera beat",
    "fishingSpotsTitle": "Fiskeplatser",
    "seePermits": "Se fiskekort"
  },
  "fiskekort": {
    "purchaseTitle": "Köp fiskekort",
    "product": "Produkt",
    "vald": "Vald",
    "validFrom": "Första dag",
    "validTo": "Giltigt till",
    "price": "Pris",
    "confirm": "Bekräfta köp",
    "submitting": "Köper…",
    "success": "Fiskekort köpt!",
    "successDescription": "Kortet är nu aktivt.",
    "viewMyCards": "Visa mina fiskekort",
    "currency": "NOK",
    "paymentProcessing": "Behandlar betalning…",
    "paymentCancelled": "Betalning avbruten",
    "paymentCancelledDesc": "Du kan försöka köpa kortet igen.",
    "paymentPending": "Betalning mottagen",
    "paymentPendingDesc": "Vi väntar på bekräftelse från betalningsleverantören. Ditt kort visas under Mina fiskekort när betalningen är bekräftad.",
    "seasonNote": "Säsong: {{open}} – {{close}}",
    "errorBeforeSeason": "Valt datum är utanför säsongen. Säsongen öppnar {{open}}.",
    "errorAfterSeason": "Kortet sträcker sig förbi säsongsslut ({{close}}). Välj ett tidigare startdatum.",
    "disinfectionTitle": "Desinfektion (obligatorisk)",
    "disinfectionHint": "Den här älven kräver att du bekräftar att utrustning och/eller båt är desinficerad.",
    "disinfectionRequired": "Du måste välja en desinfektionsmetod.",
    "disinfectionMethod": {
      "dried_2weeks": "Torkat i minst 2 veckor",
      "frozen": "Fryst",
      "heat_treated": "Värmebehandlat (minst 60 °C)",
      "chemical": "Kemiskt desinficerat"
    },
    "quantity": "Antal fiskekort",
    "totalPrice": "Totalt pris"
  },
  "myFiskekort": {
    "title": "Mina fiskekort",
    "empty": "Du har inga fiskekort ännu.",
    "validFrom": "Från",
    "validTo": "Till",
    "status": "Status",
    "status_confirmed": "Aktiv",
    "status_cancelled": "Avbokad",
    "status_pending": "Väntar",
    "vald": "Vald",
    "product": "Typ",
    "price": "Betalt",
    "bookAgain": "Boka igen →",
    "showProof": "Visa bevis",
    "registerCatch": "Registrera fångst"
  },
  "myBookings": {
    "title": "Mina bokningar",
    "empty": "Du har inga bokningar ännu.",
    "listing": "Boende",
    "checkIn": "Incheckning",
    "checkOut": "Utcheckning",
    "guests": "Gäster",
    "total": "Totalt",
    "status_confirmed": "Bekräftad",
    "status_cancelled": "Avbokad",
    "status_pending": "Väntar",
    "cancelBtn": "Avboka",
    "cancelConfirm": "Är du säker på att du vill avboka denna bokning?",
    "cancelling": "Avbokar…",
    "cancelError": "Kunde inte avboka. Försök igen.",
    "refundNote": "Bokning avbokad. Återbetalning hanteras manuellt inom 5 arbetsdagar."
  },
  "valdAdmin": {
    "title": "Vald-administration",
    "myValds": "Mina vald",
    "selectVald": "Välj ett vald att administrera",
    "searchVald": "Sök vald…",
    "catchesThisYear": "Fiske i år",
    "totalCatches": "Totalt fiske",
    "fiskekortTitle": "Fiskekort",
    "addProduct": "Lägg till fiskekort",
    "editProduct": "Redigera",
    "deactivateProduct": "Inaktivera",
    "noProducts": "Inga fiskekort konfigurerade ännu",
    "description": "Beskrivning",
    "savedDescription": "Sparat!",
    "saveDescription": "Spara beskrivning",
    "purchasesTitle": "Sålda fiskekort",
    "noPurchases": "Inga försäljningar ännu",
    "productName": "Namn",
    "productPrice": "Pris (øre)",
    "productDuration": "Varaktighet (dagar)",
    "productSeasonStart": "Säsongstart (YYYY-MM-DD)",
    "productSeasonEnd": "Säsongsslut (YYYY-MM-DD)",
    "productQuota": "Kvot (tomt = obegränsat)",
    "save": "Spara",
    "cancel": "Avbryt",
    "saving": "Sparar…",
    "confirmDeactivate": "Inaktivera den här produkten?",
    "confirmForceDeleteProduct": "Produkten har bekräftade köp. Radera permanent (inklusive alla köp)? Detta kan inte ångras.",
    "purchaseFisher": "Fiskare",
    "purchaseProduct": "Produkt",
    "purchaseValid": "Giltig",
    "purchaseStatus": "Status",
    "purchasePaid": "Betalt",
    "backToValds": "Tillbaka till vald-översikt",
    "viewPublicPage": "Visa offentlig sida",
    "tabFiskekort": "Fiskekort",
    "tabAccommodation": "Boende",
    "tabPackages": "Paket",
    "tabSettings": "Inställningar",
    "tabRevenue": "Intäkter",
    "addListing": "Lägg till boende",
    "editListing": "Redigera",
    "deactivateListing": "Inaktivera",
    "activateListing": "Aktivera",
    "managePhotos": "Bilder",
    "addPhoto": "Lägg till bild",
    "deletePhoto": "Ta bort bild",
    "uploadingPhoto": "Laddar upp...",
    "confirmDeletePhoto": "Ta bort den här bilden?",
    "noListings": "Inga boendelistningar ännu",
    "listingName": "Namn",
    "listingType": "Typ",
    "listingCapacity": "Kapacitet (personer)",
    "listingPrice": "Pris per natt (øre)",
    "listingDesc": "Beskrivning",
    "listingProximityNote": "Avstånd till fiskeplatsen",
    "listingProximityNotePlaceholder": "t.ex. 5 min bilkörning från zon 2",
    "listingOpenFrom": "Öppen från (MM-DD)",
    "listingOpenTo": "Öppen till (MM-DD)",
    "listingMinNights": "Min. nätter",
    "listingMaxNights": "Max. nätter",
    "blockedPeriods": "Blockerade perioder",
    "noBlockedPeriods": "Inga blockerade perioder.",
    "addBlockedPeriod": "Lägg till blockering",
    "blockedFrom": "Från",
    "blockedTo": "Till",
    "blockedReason": "Anledning (valfritt)",
    "blockedReasonHint": "t.ex. Underhåll",
    "bookingsTitle": "Bokningsförfrågningar för {{name}}",
    "noBookings": "Inga bokningsförfrågningar",
    "bookingGuest": "Gäst",
    "bookingDates": "Datum",
    "bookingStatus": "Status",
    "bookingConfirm": "Bekräfta",
    "bookingCancel": "Avböj",
    "bookingStatus_pending": "Väntar",
    "bookingStatus_confirmed": "Bekräftad",
    "bookingStatus_cancelled": "Avböjd",
    "addPackage": "Lägg till paket",
    "editPackage": "Redigera",
    "deletePackage": "Ta bort",
    "noPackages": "Inga paket ännu",
    "packageName": "Namn",
    "packageDesc": "Beskrivning",
    "packageFiskekort": "Fiskekort (valfritt)",
    "packageAccommodation": "Boende (valfritt)",
    "packageCombinedPrice": "Kombinerat pris i øre (valfritt)",
    "packageNone": "— ingen —",
    "contactTitle": "Kontaktinfo (Om oss)",
    "contactName": "Namn / organisation",
    "contactPhone": "Telefon",
    "contactEmail": "E-post",
    "contactWebsite": "Webbplats",
    "saveContact": "Spara kontaktinfo",
    "fishingOptionsTitle": "Fiskealternativ",
    "suitableForFlyFishing": "Lämplig för flugfiske",
    "fishingFromBoat": "Fiske från båt tillgängligt",
    "saveFishingOptions": "Spara fiskealternativ",
    "seasonPicker": {
      "yearRound": "Hela säsongen",
      "yearRoundNote": "Tillgängligt hela året",
      "selectStart": "Klicka för att välja startdatum",
      "selectEnd": "välj slutdatum"
    },
    "calendarPreview": "Visa kalenderförhandsvisning",
    "calendarPreviewHide": "Dölj kalenderförhandsvisning",
    "setupChecklist": {
      "title": "Kom igång – konfigurera ditt vald",
      "step1": "Beskriv valdet",
      "step2": "Lägg till fiskekort-produkt",
      "step3": "Lägg till boende",
      "step4": "Skapa paket",
      "optional": "valfritt",
      "packageHint": "Skapa en fiskekort-produkt och ett boendealternativ först innan du skapar ett paket."
    }
  },
  "accommodation": {
    "bookTitle": "Boka boende",
    "listing": "Boende",
    "checkIn": "Incheckning",
    "checkOut": "Utcheckning",
    "guestCount": "Antal gäster",
    "guestName": "Ditt namn",
    "guestEmail": "E-post",
    "guestPhone": "Telefon (valfritt)",
    "notes": "Meddelande till ägaren (valfritt)",
    "totalPrice": "Totalpris",
    "totalNights": "{{count}} natt",
    "totalNights_plural": "{{count}} nätter",
    "bookBtn": "Skicka bokningsförfrågan",
    "submitting": "Skickar…",
    "success": "Förfrågan skickad!",
    "successDetail": "Ägaren kontaktar dig för att bekräfta.",
    "loginRequired": "Du måste vara inloggad för att boka boende",
    "perNight": "/ natt",
    "datesUnavailable": "Dessa datum är inte tillgängliga, välj andra datum",
    "paymentProcessing": "Bearbetar betalning…",
    "paymentConfirmed": "Betalning bekräftad!",
    "paymentConfirmedDesc": "Din bokning är bekräftad. Vi ser fram emot ditt besök!",
    "paymentCancelled": "Betalning avbruten",
    "paymentCancelledDesc": "Betalningen avbröts. Du kan försöka igen.",
    "paymentPending": "Betalning väntar",
    "paymentPendingDesc": "Betalningen är inte bekräftad ännu. Kontrollera Mina bokningar snart.",
    "viewMyBookings": "Se mina bokningar",
    "unavailablePeriods": "Bokade perioder",
    "blockedPeriods": "Blockerade perioder",
    "seasonWindow": "Säsongen öppen {{from}} – {{to}}",
    "minNightsHint": "Minst {{count}} nätter",
    "maxNightsHint": "Högst {{count}} nätter",
    "minNightsError": "Minst {{count}} nätter krävs",
    "maxNightsError": "Max {{count}} nätter tillåtna",
    "outsideSeason": "Valda datum är utanför öppen säsong"
  },
  "fiskekortList": {
    "title": "Lediga fiskekort",
    "intro": "Bläddra och köp fiskekort",
    "noProducts": "Inga fiskekort tillgängliga just nu",
    "buy": "Köp",
    "soldOut": "Slutsalt",
    "unlimited": "Obegränsat",
    "remaining": "{{count}} kvar",
    "durationDay": "1 dag",
    "durationDays": "{{count}} dagar",
    "calendarView": "Kalender",
    "listView": "Lista",
    "noProductsDay": "Inga fiskekort tillgängliga denna dag",
    "legendAvailable": "Lediga",
    "legendSoldOut": "Slutsålt"
  },
  "fishingDay": {
    "title": "Logga fiskedag",
    "intro": "Registrera att du har fiskat idag utan att fånga något.",
    "submit": "Logga fiskedag",
    "submitting": "Loggar…",
    "success": "Fiskedag registrerad!",
    "successCta": "Vill du registrera en fångst?",
    "calendarTitle": "Dina fiskedagar",
    "noCatches": "ingen fångst",
    "catchCount_one": "{{count}} fångst",
    "catchCount_other": "{{count}} fångster",
    "delete": "Ta bort",
    "confirmDelete": "Ta bort denna fiskedag?"
  },
  "contact": {
    "title": "Kontakta oss",
    "intro": "Har du frågor eller åsikter? Skicka ett meddelande, så svarar vi så snart vi kan.",
    "name": "Namn",
    "email": "E-postadress",
    "message": "Meddelande",
    "send": "Skicka meddelande",
    "sending": "Skickar...",
    "successMessage": "Tack! Vi har tagit emot ditt meddelande och svarar snart.",
    "errorMessage": "Något gick fel. Försök igen."
  },
  "revenue": {
    "title": "Intäkter",
    "year": "År",
    "fiskekortTotal": "Fiskekort",
    "bookingsTotal": "Boende",
    "grandTotal": "Totalt",
    "fiskekortSales": "Sålda fiskekort",
    "accommodationBookings": "Boendebokningar",
    "noData": "Inga data för valt år.",
    "exportCsv": "Ladda ned CSV",
    "product": "Produkt",
    "date": "Datum",
    "amount": "Belopp",
    "listing": "Objekt",
    "checkIn": "Incheckning",
    "checkOut": "Utcheckning",
    "guest": "Gäst",
    "payoutStatus": "Utbetalt",
    "payoutDone": "Ja",
    "payoutPending": "Nej"
  },
  "packageOrder": {
    "title": "Beställ paket",
    "priceBreakdown": "Prisöversikt",
    "fiskekortPart": "Fiskekort",
    "accommodationPart": "Boende",
    "combinedTotal": "Samlat pris",
    "validFrom": "Kortstart (incheckning)",
    "checkIn": "Incheckning",
    "checkOut": "Utcheckning",
    "guestCount": "Antal gäster",
    "guestName": "Ditt namn",
    "guestEmail": "E-post",
    "guestPhone": "Telefon (valfritt)",
    "notes": "Meddelande (valfritt)",
    "submitBtn": "Beställ och betala",
    "submitting": "Skickar…",
    "paymentProcessing": "Behandlar betalning…",
    "paymentConfirmed": "Paket beställt!",
    "paymentConfirmedDesc": "Fiskekort och boende bekräftat. Lycka till!",
    "paymentPending": "Betalning väntar",
    "paymentPendingDesc": "Betalning ej bekräftad ännu. Kolla Mina beställningar om en stund.",
    "paymentCancelled": "Betalning avbruten",
    "paymentCancelledDesc": "Du kan försöka igen.",
    "viewMyBookings": "Se mina bokningar",
    "loginRequired": "Du måste logga in för att beställa ett paket"
  },
  "riverPage": {
    "notFound": "Hittade inte älven",
    "temporarilyClosed": "Tillfälligt stängd",
    "requiresDisinfection": "Desinfektion krävs",
    "packagesSection": "Paket — fiskekort + boende",
    "valdsSection": "Fiskezoner och fiskekort",
    "accommodationSection": "Boende",
    "viewVald": "Se vald",
    "noValds": "Inga zoner registrerade",
    "noProductsForVald": "Inga kort tillgängliga",
    "mapSection": "Karta över vattendraget",
    "fishingRulesTitle": "Fiskeregler",
    "eventsSection": "Vad händer under säsongen",
    "staySection": "Bo, ät och upplev vid {{name}}",
    "readMore": "Läs mer",
    "placeCategory_hotel": "Hotell",
    "placeCategory_restaurant": "Restaurang",
    "placeCategory_camping": "Camping",
    "placeCategory_cabin": "Stugor",
    "placeCategory_shop": "Butik",
    "placeCategory_other": "Övrigt",
    "filterValds": "Sök vald…",
    "noValdMatch": "Inga vald matchar sökningen",
    "fromPrice": "från {{price}}",
    "cardCount_one": "{{count}} kort",
    "cardCount_other": "{{count}} kort",
    "noCardsAvailable": "Inga kort tillgängliga",
    "showAllValds": "Visa alla {{count}} vald",
    "seePermits": "Se fiskekort",
    "nearbyFilter_all": "Alla",
    "nearbyFilter_stay": "Boende",
    "nearbyFilter_eat": "Mat",
    "nearbyFilter_shop": "Butiker",
    "nearbyFilter_other": "Övrigt",
    "nearbyNear": "Närmast",
    "nearbyNearNone": "Ingen vald",
    "nearbyDistance": "{{km}} km fågelvägen från {{vald}}",
    "nearbyBookable": "Kan bokas här",
    "nearbyAd": "Sponsrat innehåll",
    "nearbyTag_fiskekort": "Säljer fiskekort",
    "nearbyTag_tackle": "Fiskeutrustning",
    "nearbyTag_guide": "Guide",
    "nearbyTag_boat": "Båtuthyrning",
    "nearbyTag_drying": "Torkrum",
    "nearbyTag_freezer": "Frys",
    "nearbyTag_earlyBreakfast": "Tidig frukost",
    "mapLayer_valds": "Valds",
    "mapLayer_spots": "Fiskeplatser",
    "nearbySponsor": "Stöder {{river}}",
    "nearbyPick": "Rekommenderas av älvägarlaget",
    "nearbyShowOnMap": "Visa på karta",
    "sponsorsRow": "Stöds av",
    "placeCategory_attraction": "Sevärdhet",
    "nearbyFilter_see": "Upplevelser",
    "nearbyFilter_family": "Familj",
    "nearbyFamily": "För hela familjen",
    "nearbyVisit": "Besök webbplats",
    "nearbyCall": "Ring",
    "sponsorMain": "Huvudsponsor"
  },
  "fiskekortBevis": {
    "statusActive": "Aktiv — fiskekort giltigt",
    "refLabel": "Ref",
    "print": "Skriv ut / Dela",
    "catchCtaText": "Fångat något? Glöm inte att registrera din fångst!",
    "catchCtaBtn": "Registrera fångst"
  },
  "discovery": {
    "title": "Hitta fiskekort till norska laxälvar",
    "intro": "Utforska fiskevatten och köp fiskekort av valdägare som säljer via Lakseborsen. Filtrera efter älv, fisketeknik eller tillgänglighet.",
    "filterRiver": "Filtrera efter älv",
    "allRivers": "Alla älvar",
    "flyFishing": "Flugfiske",
    "boatFishing": "Båtfiske",
    "hasFiskekort": "Fiskekort",
    "clearFilters": "Rensa filter",
    "resultCount": "{{count}} fiskevatten",
    "noResults": "Inga fiskevatten matchar filtret.",
    "buyFiskekort": "Köp fiskekort",
    "seeVald": "Se fiskevatten",
    "searchPlaceholder": "Sök efter fiskevatten eller älv",
    "sortLabel": "Sortera",
    "sortName": "Namn (A-Ö)",
    "sortPrice": "Pris"
  },
  "bliValdeier": {
    "title": "Bli valdägare",
    "lead": "Du har blivit inbjuden att bli valdägare för {{valdName}} på {{riverName}}.",
    "vald": "Vald",
    "river": "Älv",
    "loginHint": "Logga in med kontot registrerat på inbjudningsadressen för att acceptera.",
    "loginAndAccept": "Logga in och acceptera",
    "autoClaimHint": "Slutför registrering…",
    "claiming": "Registrerar ägarskap…",
    "successTitle": "Välkommen som valdägare!",
    "successDesc": "Du är nu registrerad som ägare av {{valdName}}.",
    "goToValdAdmin": "Gå till vald-admin",
    "notFoundTitle": "Inbjudan hittades inte",
    "notFoundDesc": "Länken är ogiltig eller har löpt ut.",
    "expiredTitle": "Inbjudan har gått ut",
    "expiredDesc": "Be administratören skicka en ny inbjudan.",
    "claimedTitle": "Redan använd",
    "claimedDesc": "Denna inbjudan har redan accepterats.",
    "errorTitle": "Något gick fel"
  },
  "komIGang": {
    "selectVald": "Välj vald",
    "chooseVald": "Välj ett vald",
    "step1Title": "Kontaktinformation",
    "step1Desc": "Ange kontaktuppgifter och en beskrivning av valdet. Detta visas offentligt.",
    "contactName": "Kontaktperson",
    "contactNamePlaceholder": "Namn eller organisation",
    "phone": "Telefon",
    "email": "E-post",
    "website": "Webbplats",
    "description": "Beskrivning",
    "descriptionPlaceholder": "Berätta om valdet, fiskemöjligheter, regler m.m.",
    "step2Title": "Karta och fiskesätt",
    "step2Desc": "Placera valdet på kartan, rita gränser och välj fisketekniker.",
    "mapLocation": "Kartposition (klicka för att placera)",
    "polygon": "Valdgräns (valfritt)",
    "flyFishing": "Lämplig för flugfiske",
    "boatFishing": "Fiske från båt möjligt",
    "step3Title": "Fiskeplatser",
    "step3Desc": "Lägg till specifika fiskeplatser på kartan (valfritt).",
    "step3Hint": "Du kan lägga till fiskeplatser från vald-adminpanelen när som helst.",
    "back": "Tillbaka",
    "nextStep": "Nästa steg",
    "skipWizard": "Hoppa över",
    "goToValdAdmin": "Gå till vald-admin"
  },
  "installPrompt": {
    "text": "Lägg till Lakseborsen på hemskärmen för snabbare åtkomst",
    "iosHint": "Lägg till Lakseborsen på hemskärmen: öppna Dela-menyn i webbläsaren och välj ”Lägg till på hemskärmen”.",
    "install": "Lägg till",
    "dismiss": "Stäng"
  },
  "textSize": {
    "label": "Textstorlek",
    "normal": "Normal textstorlek",
    "large": "Stor textstorlek",
    "xlarge": "Extra stor textstorlek"
  },
  "statsSection": {
    "title": "Statistik och grafer",
    "yearLabel": "Säsong",
    "tooFewData": "Mer data behövs för att visa denna statistik",
    "noCatchesForYear": "Inga registrerade fångster denna säsong",
    "loading": "Laddar statistik…",
    "axisCatches": "Fångster",
    "axisAvgWeight": "Snittvikt (kg)",
    "axisWeek": "Vecka",
    "axisHour": "Timme",
    "kpi": {
      "totalCatches": "Antal fångster",
      "totalWeight": "Total vikt",
      "avgWeight": "Snittvikt",
      "biggestFish": "Största fisken",
      "releaseRate": "Andel återutsatt",
      "uniqueAnglers": "Aktiva fiskare",
      "cpue": "Fångst per fiskare",
      "fishingHours": "Fisketimmar",
      "catchesPerHour": "Fångst per timme",
      "anglersNow": "Fiskare nu"
    },
    "fishType": {
      "title": "Fördelning per fiskart",
      "subtitle": "Antal fångster per art"
    },
    "gear": {
      "title": "Vilket redskap fångar mest?",
      "subtitle": "Fångster fördelade på redskap"
    },
    "weekly": {
      "title": "När på säsongen är fisket bäst?",
      "subtitle": "Fångster per vecka"
    },
    "hour": {
      "title": "Vilken tid på dagen nappar det?",
      "subtitle": "Fångster per timme på dygnet"
    },
    "airTemp": {
      "title": "Lufttemperatur och fångst",
      "subtitle": "Antal fångster och snittvikt per temperatur"
    },
    "waterTemp": {
      "title": "Vattentemperatur och fångst",
      "subtitle": "Antal fångster och snittvikt per temperatur"
    },
    "waterFlow": {
      "title": "Vattenföring och fångst",
      "subtitle": "Antal fångster och snittvikt per vattenföringsnivå"
    },
    "historicalHeader": "Historisk översikt",
    "yearly": {
      "title": "Fångster per säsong",
      "subtitle": "Totalt antal registrerade fångster, år för år"
    },
    "typical": {
      "title": "Typisk säsong jämfört med i år",
      "subtitle": "Veckogenomsnitt baserat på {{yearCount}} historiska säsonger",
      "avgLabel": "Snitt",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Största fångsterna genom tiderna",
      "subtitle": "Topp 10 — klicka för att se fångsten"
    },
    "showAllCharts": "Visa alla diagram"
  },
  "notFound": {
    "title": "Sidan hittades inte",
    "message": "Vi kunde inte hitta sidan du letade efter.",
    "backHome": "Till startsidan"
  },
  "terms": {
    "title": "Villkor för fiske",
    "accept": "Jag har läst och godkänner villkoren",
    "mustAccept": "Du måste godkänna villkoren för att fortsätta.",
    "translationNote": "Detta är en översättning. Vid oenighet gäller den norska texten.",
    "noticeTitle": "Villkor för fiske i vattendraget",
    "noticeBody": "Det har lagts in villkor för fiske i detta vattendrag, och du har inte godkänt dem än. De gäller oavsett var du har köpt fiskekort. Du kan fortfarande registrera din fångst.",
    "readAndAccept": "Läs och godkänn villkoren",
    "acceptNow": "Jag godkänner villkoren",
    "acceptFailed": "Kunde inte spara ditt godkännande. Försök igen."
  },
  "checkin": {
    "intro": "Fiskar du nu? Starta fiskandet så att älvägarlaget kan se hur mycket fisketid som ligger bakom fångsterna.",
    "start": "Starta fiske nu",
    "end": "Klar med fisket",
    "active": "Du fiskar på {{vald}}",
    "endFailed": "kunde inte avsluta",
    "pickVald": "Välj vald nedan först.",
    "privacy": "Vi sparar bara tidpunkter, inte position.",
    "sessions": {
      "title": "Dina pass",
      "intro": "Glömde du att trycka på ”Starta fiske” eller ”Klar med fisket”? Lägg till eller rätta passet här. Tiderna är självrapporterade, och du kan lägga till pass från de senaste 60 dagarna (högst 14 timmar per pass).",
      "empty": "Inga pass ännu.",
      "add": "Lägg till pass",
      "edit": "Redigera",
      "delete": "Ta bort",
      "confirmDelete": "Ta bort det här passet?",
      "vald": "Vald",
      "start": "Start",
      "end": "Slut",
      "save": "Spara",
      "cancel": "Avbryt",
      "running": "Pågår",
      "unknown": "Okänd varaktighet: rätta passet",
      "manual": "inlagt manuellt",
      "hm": "{{h}} h {{m}} min",
      "errors": {
        "end_before_start": "Slut måste vara efter start.",
        "too_long": "Ett pass kan vara högst 14 timmar.",
        "in_future": "Tidpunkten kan inte vara i framtiden.",
        "too_old": "Du kan bara lägga till pass från de senaste 60 dagarna.",
        "overlap": "Passet överlappar ett annat pass du har.",
        "open_session": "Avsluta passet med ”Klar med fisket” i stället.",
        "end_required": "Ange när passet slutade.",
        "vald_not_found": "Hittade inte valdet.",
        "generic": "Kunde inte spara passet. Försök igen."
      }
    }
  },
  "elvekort": {
    "notFound": "Hittade inte älvkortet.",
    "voluntary": "Älvkort är frivilligt. Du behöver det inte för att köpa fiskekort eller registrera fångst.",
    "buy": "Köp älvkort",
    "validPeriod": "Giltigt {{from}} – {{to}}",
    "myCards": "Mina älvkort",
    "offerTitle": "Älvkort för vattendraget",
    "confirmedTitle": "Älvkortet är köpt",
    "cancelledTitle": "Betalningen avbröts",
    "processing": "Behandlar betalningen…",
    "pendingHint": "Betalningen är inte bekräftad ännu. Kolla ”Mina älvkort” om en stund."
  },
  "riversPage": {
    "metaTitle": "Älvar och vald – laxälvar i Norge | Lakseborsen",
    "metaDescription": "Översikt över laxälvar och vald med fiskekort, säsong och boende.",
    "title": "Älvar och vald",
    "intro": "Alla älvar på Lakseborsen med valden i varje älv. Välj en älv för säsong, regler, boende och matställen i närheten.",
    "closed": "Tillfälligt stängd",
    "valds": "Vald",
    "seeRiver": "Se {{river}}",
    "aboutRiver": "Om älven",
    "valdsCount": "{{count}} vald"
  }
}
